import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Sensor, TimeZoneDisplay as TimeZoneSelection } from '@models';
import { SensorService } from '@services/sensor.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { KigSettings, KIG_SETTINGS } from 'settings/kig-settings';
import { CommonShared } from 'app/shared/classes/common';
import { SensorAssociations } from '@models/Sensor/sensorAssocations.model';


export interface SensorAssociationsParams {
 sensors: Sensor[];
}

@Component({
  standalone: false,
  selector: 'app-sensor-associations-modal',
  templateUrl: './sensor-associations-modal.component.html',
  styleUrls: ['./sensor-associations-modal.component.scss']
})

export class SensorAssociationsModalComponent implements OnInit, SensorAssociationsParams {

  common = new CommonShared();
  modalDragOn: boolean = false;

  sensors: Sensor[] = [];
  sensorsAssociations: SensorAssociations[] = [];

  sensorAssociationsCols = [
    { field: 'sensor.name', header: 'Sensor Name', width: '20%' },
    { field: 'sensor.uuid', header: 'Sensor UID', width: '36%' },
    { field: 'sensorGroup.name', header: 'Sensor Groups', width: '22%' },
    { field: 'device.name', header: 'Gateways', width: '22%' }
  ];


  constructor(public bsModalRef: BsModalRef, private toastr: ToastrService, private modalService: BsModalService,
              @Inject(KIG_SETTINGS) private settings: KigSettings, public _sensorService: SensorService) {
  }


  ngOnInit(): void {
    this.getSensorAssociations();
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  getSensorAssociations() {
    var sensorIds = this.sensors.map(s => s.id);

    this._sensorService.showSensorAssociations(sensorIds).subscribe(
      results => {
        this.sensorsAssociations = results;
      },
      err => {
        this.toastr.error("Error getting sensors associations");
      });
  }


}
